<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gJIen8/tc-custom/9781940709536.jpg?1731411176928" alt="This image is the cover for the book Dragonesque"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dragonesque
      </h1>
      <p class="bookDescription body article font2">
        <p>Is anything more terrifying than a dragon? Bat-winged nightmares swooping down from the sky to breathe fire and ice on the wretched humans below; kidnapping princesses, hoarding treasure, swallowing cows. Or not. In DRAGONESQUE, the latest fantastic anthology from Zombies Need Brains, you finally get to experience all that awfulness from the dragon’s point of view. And what if it isn’t necessarily that awful? What if the princess wants to be kidnapped, or the dragon is tired of being made fun of week after week at the Renaissance Faire? Or maybe a dragonet just really, really wants to be a unicorn? Perhaps they’re happiest collecting art, or enjoy being tattooed? Or maybe some dragons like putting out fires more than starting them…unless they absolutely have to? DRAGONESQUE features sixteen original stories from such fiery authors as Esther M. Friesner, Madeline Dau, Niall Spain, Russell Hugh McConnell, Grace Eliza, Mike Jack Stoumbos, Paul D. Smith, Jean Marie Ward, Gerald Brandt, Gini Koch &amp; Bebe Bayliss, Larry Ivkovich, Barbara Campbell, Journey Sloane, Em McDermott, Auston Habershaw, and David B. Coe. See the world as the dragons see it, from the delightfully delicious to the tastefully transactional. Welcome to DRAGONESQUE.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Esther Friesner, Joshua Palmatier, S.C. Butler, Madeline Dau, Niall Spain, Russell Hugh McConnell, Grace Eliza, Mike Jack Stoumbos, Paul D. Smith, Jean Marie Ward, Gerald Brandt, Gini Koch, Bebe Bayliss, Larry Ivkovich, Barbara Campbell, Journey Sloane, Em McDermott, Auston Habershaw, David B. Coe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zombies Need Brains LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78e62eeb